import $ from "jquery";
// import anime from "animejs/lib/anime.es.js";

export const masthead = () => {
  const elms = {
    bannerHighlight: "#masthead",
  };

  function stickyMasthead() { 
    let scrollPos = 0;
    const nav = $(elms.bannerHighlight);

    function checkPosition() {
      let windowY = $(window).scrollTop();
      if (windowY < scrollPos || windowY === 0) {
        // Scrolling UP
        nav.addClass('is-visible');
        nav.removeClass('is-hidden');
      } else {
        // Scrolling DOWN
        nav.addClass('is-hidden');
        nav.removeClass('is-visible'); 
      }
      scrollPos = windowY;
    }

    window.addEventListener('scroll', checkPosition);
  }

  function employeeContact() {
    $("#employee-contact").each(function() {
      const $phonenum = $(this).find(".elementor-icon-list-item .fa-phone-alt");
      const $emailList = $(this).find(".elementor-icon-list-item .fa-envelope");
      const $phonenumParent = $phonenum.closest("a");
      const $emailListParent = $emailList.closest("a");
      const phonenumber = $phonenumParent.attr("href");
      const emailAddress = $emailListParent.attr("href");

      if (phonenumber) {
        const fixedPhonenumX = phonenumber.replace('http://', '').replace('https://', '');
        $phonenumParent.attr("href", "tel:" + fixedPhonenumX);
      }

      if (emailAddress) {
        const fixedemailAddress = emailAddress.replace('http://', '').replace('https://', '');
        
        if (emailAddress.indexOf('mailto:') > -1) {
          $emailListParent.addClass("is-valid");
        } else {
          $emailListParent.attr("href", "mailto:" + fixedemailAddress);
        }
      }
    })
  }

  stickyMasthead();
  employeeContact();
};
 